import React from 'react'
import cx from 'classnames'

const HelpHardinessCard = ({
  number,
  title,
  theme,
  description,
  quote,
}) => (
  <article className={cx('HelpHardinessCard', `HelpHardinessCard--${theme}`)}>
    <header className="HelpHardinessCard__header">
      <span className="HelpHardinessCard__number">{number}</span>
      <div className="HelpHardinessCard__heading">
        <span className="HelpHardinessCard__title">{title}</span>
      </div>
    </header>
    <p className="HelpHardinessCard__description">{description}</p>
    <blockquote className="HelpHardinessCard__quote">
      <span className="HelpHardinessCard__quoteIcon" aria-hidden="true">
        “
      </span>
      <p>{quote}</p>
    </blockquote>
  </article>
)

export default HelpHardinessCard
